import { useState, useEffect } from "react";
import {
  Box, Typography, Card, CardContent, Chip,
  CircularProgress, IconButton, Divider
} from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

const token = () => localStorage.getItem("biyz_token");
const authHead = () => ({ Authorization: "Bearer " + token() });

function fmtDate(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleDateString("tr-TR", { day: "2-digit", month: "2-digit", year: "numeric" })
    + " " + d.toLocaleTimeString("tr-TR", { hour: "2-digit", minute: "2-digit" });
}

export default function SupportPage() {
  const [tickets, setTickets] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const limit = 10;

  const fetchTickets = (p) => {
    setLoading(true);
    fetch("/api/platform/support?page=" + p + "&limit=" + limit, { headers: authHead() })
      .then(r => r.json())
      .then(data => {
        setTickets(data.data || []);
        setTotal(data.total || 0);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  useEffect(() => { fetchTickets(page); }, [page]);

  const totalPages = Math.max(1, Math.ceil(total / limit));

  return (
    <Box sx={{ maxWidth: 780, mx: "auto", px: 2, py: 4 }}>
      <Typography variant="h6" fontWeight={700} sx={{ mb: 3 }}>Biletlerim</Typography>

      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 6 }}>
          <CircularProgress />
        </Box>
      ) : tickets.length === 0 ? (
        <Typography color="text.secondary">Henuz bilet bulunmuyor.</Typography>
      ) : (
        tickets.map(t => {
          const firstMsg = t.messages && t.messages[0] ? t.messages[0].content : "";
          const shortId = "#" + String(t._id).slice(-7);
          const isOpen = t.status === "open";
          return (
            <Card key={t._id} sx={{ mb: 1.5, borderRadius: 2, boxShadow: "0 1px 4px rgba(0,0,0,0.07)" }}>
              <CardContent sx={{ display: "flex", alignItems: "center", gap: 2, py: "12px !important" }}>
                <Chip
                  label={isOpen ? "Acik" : "Kapali"}
                  size="small"
                  sx={{
                    bgcolor: isOpen ? "#2e7d32" : "#757575",
                    color: "white", fontWeight: 700, fontSize: 11, minWidth: 52
                  }}
                />
                <Typography variant="body2" fontWeight={600} sx={{ minWidth: 70 }}>{shortId}</Typography>
                <Typography variant="body2" color="text.secondary" noWrap sx={{ flexGrow: 1 }}>
                  {firstMsg}
                </Typography>
                <Typography variant="caption" color="text.secondary" sx={{ whiteSpace: "nowrap" }}>
                  {fmtDate(t.createdAt)}
                </Typography>
              </CardContent>
            </Card>
          );
        })
      )}

      {totalPages > 1 && (
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 2, mt: 3 }}>
          <IconButton onClick={() => setPage(p => Math.max(1, p - 1))} disabled={page === 1}>
            <ChevronLeftIcon />
          </IconButton>
          <Typography variant="body2">{page}</Typography>
          <IconButton onClick={() => setPage(p => Math.min(totalPages, p + 1))} disabled={page === totalPages}>
            <ChevronRightIcon />
          </IconButton>
        </Box>
      )}

      <Divider sx={{ my: 3 }} />
      <Box sx={{ display: "flex", justifyContent: "center", gap: 3 }}>
        {["KVKK", "Gizlilik Politikasi", "Mesafeli Satis Sozlesmesi"].map(label => (
          <Typography key={label} variant="caption" color="text.secondary"
            sx={{ cursor: "pointer", "&:hover": { textDecoration: "underline" } }}>
            {label}
          </Typography>
        ))}
      </Box>
    </Box>
  );
}
